import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC, useMemo } from "react";
import OfferningsModal from "@Modules/eventPage/components/OfferingsModal";
import { Button } from "repoV2/components/common/Button";
import { useBonusOfferingContext } from "@Modules/eventPage/components/RenewBookingForm/utils/BonusOfferingContext";
import { useIsDesktop } from "repoV2/utils/common/render/screen";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import styles from "./brandedOfferings.module.scss";
import { IBrandedCommunityOfferings } from "./IBrandedCommunityOfferings";
import BrandedCommunityOffering from "./components/BrandedCommunityOffering";
import commonStyles from "../commonStyles.module.scss";

const BrandedCommunityOfferings: FC<IBrandedCommunityOfferings> = ({
    isEventModal = false,
}) => {
    const [isModalOpen, setsModalOpen] = React.useState(false);
    const isMobile: boolean = !useIsDesktop();

    const isLoading = false;

    const { bonusOfferings } = useBonusOfferingContext() || {};
    /**
     * Case1:Show first two offerings on the event page if bonus offerings are more than 2
     * The rest of the offerings will be shown in see more offerings modal
     * Case2:If Event Modal is Opened we show all the offerings in a horizontal scroller
     */
    const bonusOfferingsToMap = useMemo(() => {
        return !isEventModal && !isMobile && bonusOfferings?.length > 2
            ? bonusOfferings.slice(0, 2)
            : bonusOfferings;
    }, [isEventModal, bonusOfferings]);

    const offeringModalProps = {
        open: isModalOpen,
        onClose: () => {
            setsModalOpen(false);
        },
        bonusOfferings,
    };

    if (checkIsArrayEmpty(bonusOfferings)) return null;

    return (
        <div
            className={classNames(
                commonStyles.detailsSection,
                commonStyles.detailsSectionBody
            )}
        >
            <div className={commonStyles.detailsSectionTitle}>
                Bonus Offerings with Community
            </div>
            {isLoading ? (
                <div className={classNames("loader8", styles.loader)} />
            ) : (
                <div
                    className={classNames(
                        styles.detailsSectionBody,
                        styles.root
                    )}
                >
                    <div className={styles.cardsContainer}>
                        {bonusOfferingsToMap?.map(item => (
                            <React.Fragment key={item.uuid}>
                                {" "}
                                <BrandedCommunityOffering item={item} />
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )}
            {!isMobile && !isEventModal && bonusOfferings?.length > 2 && (
                <Button
                    onClick={() => {
                        setsModalOpen(true);
                    }}
                    className={styles.Styledbutton}
                >
                    See all {bonusOfferings?.length} offerings
                </Button>
            )}

            <OfferningsModal {...offeringModalProps} />
        </div>
    );
};

export default BrandedCommunityOfferings;
